import { LARGE, MEDIUM, SMALL, X_SMALL } from 'lib/DeviceScreen';
import { LEADERBOARD, MEDIUM_RECTANGLE } from 'lib/GoogleAds/Sizes';
import ProximityAd from './ProximityAd';

export const ADS_DICTIONARY: Record<string, any> = {
  'dt-wide-breaker': (
    <ProximityAd
      adConfig={{
        targeting: { inLine: 5 },
        dimensions: [[728, 90]],
        screenSizes: [LARGE],
      }}
      placeholderSize={LEADERBOARD}
    />
  ),
  'm-box-1': (
    <ProximityAd
      adConfig={{
        targeting: { inLine: 6 },
        dimensions: [
          [320, 50],
          [300, 250],
        ],
        screenSizes: [MEDIUM, SMALL, X_SMALL],
      }}
      placeholderSize={MEDIUM_RECTANGLE}
    />
  ),
  'm-box-2': (
    <ProximityAd
      adConfig={{
        targeting: { inLine: 7 },
        dimensions: [
          [320, 50],
          [300, 250],
        ],
        screenSizes: [MEDIUM, SMALL, X_SMALL],
      }}
      placeholderSize={MEDIUM_RECTANGLE}
    />
  ),
  'm-box-breaker': (
    <ProximityAd
      adConfig={{
        targeting: { inLine: 9 },
        dimensions: [
          [320, 50],
          [300, 250],
        ],
        screenSizes: [MEDIUM, SMALL, X_SMALL],
      }}
      placeholderSize={MEDIUM_RECTANGLE}
    />
  ),
};

interface ContentAdProps {
  adType: string;
}

export default function ContentAd({ adType }: ContentAdProps): JSX.Element {
  const ad = ADS_DICTIONARY[adType] || null;

  if (!ad) {
    console.error(
      `Ad type ${adType} is not a valid in-content ad type, valid types are ${Object.keys(
        ADS_DICTIONARY
      )}`
    );
  }

  return ad;
}
